import { UserContextData } from '@/store/slices/userContext/types';
import { Logger } from '@/utilities/logger/datadog/rumEvents/rumEvents';
import { DdEventCategory, DdEventType } from '@/utilities/logger/datadog/types';
import {
  setUserContext,
  setUserContextStatus,
  setUserContextError,
} from '@/store/actions';
import { emptySliceError } from '@/store/slices/sliceError';

const handleUserContextData = (data: UserContextData) => {
  setUserContext({ data });
  setUserContextStatus({ loading: false });
  setUserContextError(emptySliceError());

  Logger.logRumAction({
    name: '[GW][GET_USER_CONTEXT] Received',
    useCase: DdEventCategory.Initialization,
    eventType: DdEventType.Success,
    context: {
      hasAccountSettings: Boolean(data?.accountSettings),
    },
  });
};

export default handleUserContextData;
